import React, { Component } from "react";
import { withRouter } from "react-router-dom";
// import { connect } from "react-redux";
import {
  Page,
  Icon,
  Card,
  Layout,
  SkeletonBodyText,
  SkeletonPage,
  Button,
  BlockStack,
  Link,
  Toast,
  Spinner,
  // Banner,
  Text,
  InlineStack,
  InlineGrid,
  Box,
  ProgressBar,
  // RadioButton,
  Collapsible,
  Modal,
  Popover,
  ActionList,
} from "@shopify/polaris";

import {
  // ProductsMajor,
  NotificationMajor,
  OrdersMajor,
  // LinkMinor,
  // ImportStoreMajor,
  ChevronRightMinor,
  ListMajor,
  ResourcesMajor,
  ProfileMajor,
  PackageMajor,
  CaretUpMinor,
  CaretDownMinor,
  MobileHorizontalDotsMajor,
  CancelMajor,
  DuplicateMinor,
} from "@shopify/polaris-icons";
import {
  reqGetAppDashboardData,
  reqGetAliAuthor,
  reqGetUserBindSaleAndWallet,
  reqPostUserBindSale,
  reqPostUpdateUserSettings,
  reqWalletRecharge,
  reqPostBaseAction,
  reqPostPageEventReport,
  reqPostGuideDismiss,
  reqPostNoviceCoupon,
} from "../../../../api";

// import { API_DOMAIN } from '../../../../utils/constants';
import utils from "../../../../utils/utils";
import intl from "../../../../i18n/intl";
import GetGoodReviews from "../../../../components/GetGoodReviews";
// import AdvertisingDiversion from '../../../../components/AdvertisingDiversion';
// import { withTranslation } from "react-i18next";

import FourthBannerEvent from "../../../../components/FourthBannerEvent";
import AppRecommendation from "../../../../components/AppRecommendation";
// import OfficialSocialMedia from '../../../../components/OfficialSocialMedia';
// import HomeStatistics from '../../../../components/Statistics'
import { store } from "../../../../store";
import UpgradePlanModal from "../../SubscriptionPaid/components/UpgradePlanModal";
import UpgradeDiscountModal from "../../SubscriptionPaid/components/UpgradeDiscountModal";
import FulfilledOrders from "./FulfilledOrders";
import NewStartNone from "../../SubscriptionPaid/components/icons/NewStartNone";
import NewStartBlack from "../../SubscriptionPaid/components/icons/NewStartBlack";
import AppBridge from "../../../../utils/appBridge";
import StartRating from "stars-rating";
// icon
const icon = (
  <svg
    t="1673233977882"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2746"
    width="18"
    height="18"
  >
    <path
      d="M803.9 481.5L522.1 199.3a40.18 40.18 0 0 0-28.5-11.8c-10.7 0-20.9 4.2-28.5 11.8-7.5 7.6-11.8 17.8-11.8 28.5s4.2 20.9 11.8 28.5L718.5 510 465.1 763.6c-7.3 7.6-11.4 17.8-11.3 28.4 0.1 10.6 4.3 20.7 11.8 28.2 7.5 7.5 17.6 11.7 28.1 11.8 10.6 0.1 20.7-4 28.3-11.3l281.9-282.2c7.5-7.6 11.8-17.8 11.8-28.5s-4.2-21-11.8-28.5z"
      p-id="2747"
      fill="#303030"
    ></path>
    <path
      d="M570.7 514.5c0-10.7-4.2-20.9-11.8-28.5L277 203.9a40.18 40.18 0 0 0-28.5-11.8c-10.7 0-20.9 4.2-28.5 11.8-7.5 7.6-11.8 17.8-11.8 28.5s4.2 20.9 11.8 28.5l253.4 253.7-253.3 253.6c-7.3 7.6-11.4 17.8-11.3 28.4 0.1 10.6 4.3 20.7 11.8 28.2 7.5 7.5 17.6 11.7 28.1 11.8 10.6 0.1 20.7-4 28.3-11.3L558.9 543c7.5-7.5 11.8-17.8 11.8-28.5z"
      p-id="2748"
      fill="#303030"
    ></path>
  </svg>
);

// icon图标
const iconNext = (
  <svg
    t="1673675320598"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="18642"
    width="16"
    height="16"
  >
    <path
      d="M512.5 289.1l222.9 222.8-222.9 223-36.2-36.2L663 511.9 476.3 325.3z"
      p-id="18643"
      fill="#bfbfbf"
    ></path>
    <path
      d="M324.8 289.1l222.9 222.8-222.9 223-36.2-36.2 186.7-186.8-186.7-186.6z"
      p-id="18644"
      fill="#bfbfbf"
    ></path>
  </svg>
);

class Dashboard extends Component {
  state = {
    //页面动作
    loadingPage: true,
    //div class
    AliexpressDropshippingCenter: "Tabs_active-tab__3kw-b",
    LinkToAliexpress: "",
    Settings: "",
    ImportProducts: "",
    AddProducts: "",
    ChromeExtension: "",
    Notifications: "",
    MappingProduct: "",
    BulkOrders: "",
    symbol: "$",
    //当前选中
    CurrentlySelectedDiv: "AliexpressDropshippingCenter",
    //未处理的订单数量
    toOrderCount: 0,
    //未处理的主动Sourcing数量
    toSourcingCount: 0,
    //AwaitingSourcing数量
    toAwaitingSourcingCount: 0,
    //产品通知数量
    notificationCountArray: [],
    //按钮状态
    Buttonloading: false,
    isAuthToAliExpress: false,
    //传递到评星组件的好评开关
    goodRating: false,
    contactUsText: "",
    contactUsTextError: "",
    // 限制sourcing请求次数弹窗
    sourcingLimitModalShow: false,
    needToUpgrade: false, // 是否需要提示升级套餐参数
    ReUpgradeTime: 0, // 上一次升级弹窗的弹窗时间
    getGoodReviewActive: false,

    SaleId: "", //填写销售的唯一授权码
    hasSale: false, //是否已经绑定销售
    saleData: "", //销售信息
    agentData: {}, //agent信息

    walletMoney: 0.0, //钱包余额
    SetProductsPublished: false, //自动支付新订单的来源选项
    saveDataLoading: false,
    // chargeActive: false,    //钱包充值弹窗
    rechargeAmount: "", //充值金额
    rechargeAmountError: "", //金额提示
    AuthButtonDisable: false, //点击充值按钮
    PaymentMethod: 1, //支付方式 (1:PayPal 2:stripe)

    addLoading: false,
    finishedOnBoarding: false, // 用户引导是否完成，默认 false
    isShowDismissBtn: true,
    selectFlag: "last30d", // 默认选择近30天
    selectTime: [
      {
        value: "Last 30 days",
        num: "last30d",
      },
      {
        value: "Last 90 days",
        num: "last90d",
      },
      {
        value: "All time",
        num: "all",
      },
    ], //选择的时间
    souringProduct: [
      {
        title: "Pending",
        productNum: 0,
        n: 1,
        detailsText: "View details",
        path: "/admin/sourcing",
        icon: icon,
      },
      {
        title: "In processing",
        productNum: 0,
        n: 2,
        detailsText: "View details",
        path: "/admin/sourcing",
        icon: icon,
      },
      {
        title: "Failed",
        productNum: 0,
        detailsText: "View details",
        path: "/admin/sourcing",
        n: 4,
        icon: icon,
      },
      {
        title: "Success",
        productNum: 0,
        detailsText: "View details",
        path: "/admin/sourcing",
        n: 5,
        icon: icon,
      },
    ], // 传入Souring Products数据
    ordersFulfillment: [
      {
        title: "Wait to pay",
        productNum: 0,
        n: 1,
        detailsText: "View details",
        path: "/admin/order_list",
        icon: icon,
      },
      {
        title: "In transit",
        productNum: 0,
        n: 3,
        detailsText: "View details",
        path: "/admin/orders_tracking",
        icon: icon,
        img: "/sub/sub_head_light.png",
      },
      {
        title: "Delivery failed",
        productNum: 0,
        detailsText: "View details",
        n: 7,
        path: "/admin/orders_tracking",
        icon: icon,
        img: "/sub/sub_head_light.png",
      },
      {
        title: "Delivered",
        detailsText: "View details",
        n: 5,
        path: "/admin/orders_tracking",
        icon: icon,
        img: "/sub/sub_head_light.png",
      },
    ], // 传入OrdersFulfillment数据
    aliexpressAuthEffective: "", //是否有授权
    selectState: 1, //productsOrders选中状态
    solutionList: [
      {
        title: "No product, no order",
        content:
          "Multiple channels to help you get the right products for you.",
        n: 1,
        source: ProfileMajor,
        h3Color: "#303030",
        bgColor: "#f1f1f1",
        fill: "#cdcdcd",
      },
      {
        title: "Have products, no order",
        content: "One-stop solutions to help you open up sales.",
        n: 2,
        source: ProfileMajor,
        h3Color: "",
        bgColor: "",
        fill: "#cdcdcd",
      },
      {
        title: "Have products, have orders",
        content: "Perfect service to help your business sell big.",
        n: 3,
        source: ProfileMajor,
        h3Color: "",
        bgColor: "",
        fill: "#cdcdcd",
      },
    ], // There is always a solution for you List
    productsOrdersInfo: {
      1: [
        {
          title: "Product recommendation",
          content:
            "Automatically recommend products for you based on your product preferences.",
          btnText: "Search Product",
          btnfn: () => {
            utils.routeListen("/admin/find_products");
            utils.routeJump(this, "/admin/find_products");
          },
        },
        {
          title: "Free Products Sourcing",
          content:
            "Send products sourcing requests here and we will find them for you for free!",
          btnText: "Sourcing Now",
          btnfn: () => {
            utils.routeListen("/admin/sourcing");
            utils.routeJump(this, "/admin/sourcing");
          },
        },
        {
          title: "Import AliExpress Products",
          content:
            "Simply import AliExpress products to your store via the AliExpress product link.",
          btnText: "Import Products",
          btnfn: () => {
            utils.routeListen("/admin/import-list");
            utils.routeJump(this, "/admin/import-list");
          },
        },
        {
          title: "Product Import Extension",
          content: `With Dropshipman's Google Extension, you can import AliExpress or 1688 products to your store in seconds.`,
          btnText: "Get Extension",
          btnfn: () => {
            // this.props.history.push({ pathname: '/admin/sourcing' })
            // window.location.replace('https://www.dropshipman.com/blog/how-to-add-aliexpress-products-to-dropshipman-by-chrome-extension')
            window.open(
              "https://www.dropshipman.com/blog/how-to-add-aliexpress-products-to-dropshipman-by-chrome-extension"
            );
          },
        },
      ],
      2: [
        //   title: "Lower cost items",
        //   content:
        //     "We offer the same products as your store but at a lower cost, allowing you to offer more benefits to your customers.",
        //   btnText: "Sourcing Store Product",
        //   btnfn: () => {
        //     utils.routeListen("/admin/shopifyProducts");
        //     utils.routeJump(this, "/admin/shopifyProducts");
        //   },
        // },
        {
          title: "Best Sellers Recommendation",
          content:
            "We will recommend the best-selling and niche items for you, so that the items posted to your store will be very popular.",
          btnText: "Search Products",
          btnfn: () => {
            utils.routeListen("/admin/find_products");
            utils.routeJump(this, "/admin/find_products");
          },
        },
        // {
        //   title: "Website Upgrade",
        //   content:
        //     "Dropshipping experts will diagnose your website and help you upgrade its design, functionality, SEO, etc.",
        //   btnText: "View Details",
        //   btnfn: () => {
        //     utils.routeListen("/admin/websiteOptimization/website-build");
        //     utils.routeJump(this, "/admin/websiteOptimization/website-build");
        //   },
        // },
        {
          title: "Marketing Tools Integration",
          content:
            "We integrate with partners who offer reviews, credits, and shipping insurance to help you market your items.",
          btnText: "View Details",
          btnfn: () => {
            utils.routeListen("/admin/partnerShip/partners");
            utils.routeJump(this, "/admin/partnerShip/partners");
          },
        },
      ],
      3: [
        {
          title: "Fast Order Fulfillment",
          content:
            "After your order is given to us for fulfillment, we will deliver the goods safely to your customers within 7-15 days.",
          btnText: "",
        },
        {
          title: "Product quality inspection",
          content:
            "Before each item is delivered to your customers, we will conduct several strict quality checks.",
          btnText: "",
        },
        {
          title: "Full tracking of orders",
          content:
            "From the moment you place an order, we begin to provide you with the full tracking of your order.",
          btnText: "Track orders",
          btnfn: () => this.handleOrderTrackingUpgrade(),
        },
        {
          title: "Brand packaging",
          content:
            "Packaging customization services to help you build your own brand.",
          btnText: "Custom Packaging",
          btnfn: () => {
            utils.routeListen("/admin/customService/custom-packaging");
            utils.routeJump(this, "/admin/customService/custom-packaging");
          },
        },
      ],
    }, // productsOrdersContent 对应的内容
    needHelpList: [
      {
        title: "Dropshipman FAQ",
        fn: () => {
          // window.location.replace('https://www.dropshipman.com/blog/faq')
          window.open("https://www.dropshipman.com/blog/faq");
        },
        icon: iconNext,
      },
      {
        title: "24/7 Customer Support",
        fn: () => {
          // window.Intercom('show');
          window.Willdesk.show();
          window.Willdesk.chat("");
        },
        icon: iconNext,
      },
      // {
      //   title: 'Send Email for Support',
      //   fn: () => {
      //     // window.location = "mailto:sample@jsphp.net?subject=test&cc=sample@hotmail.com&subject=主题&body=内容";
      //     window.open('mailto:support@dropshipman.com')
      //   },
      //   icon: iconNext
      // }
    ], //Need any help List
    loading: false, //是否loading

    // 判断用户是否首次进入及判断用户产品和订单情况
    usageGuideInfo: {},
    showUsageGuide: true,
    showAliexpressGuide: true,

    recommendedCount: 1, // 推荐产品数
    upgradeModal: false, //升级会员限制
    isNewUser: false, //是否新用户 打开付费引导弹窗

    affiliate_banner: false, //是否展示affiliate引导
    unfulfilled_count: 0, //订单统计
    newerStartData: [
      {
        title: "About Dropshipman",
        dsc: `Watch the video to learn about Dropshipman.Get a <strong>$5 coupon</strong> reward for completing the task.`,
        video:
          "https://www.youtube.com/embed/bArgTh6VFtU?rel=0&autoplay=1&loop=1",
        isAction: true,
        stepMask: "/buildShopify/new1.png",
        coupon: false,
      },
      {
        title: "Find products from Dropshipman",
        dsc: "Watch the video to learn how to find and list products using Dropshipman and earn a <strong>$5 coupon</strong>.",
        video:
          "https://www.youtube.com/embed/nSWr8lEwlVI?rel=0&autoplay=1&loop=1",
        isAction: false,
        stepMask: "/buildShopify/new2.png",
        coupon: false,
      },
      {
        title: "How to request a sourcing",
        dsc: "Watch the video to learn find and list products from Dropshipman. Get a <strong>$5 coupon</strong> reward for completing the task.",
        video:
          "https://www.youtube.com/embed/kNUnbKidLNU?rel=0&autoplay=1&loop=1",
        isAction: false,
        stepMask: "/buildShopify/new3.png",
        coupon: false,
      },
      {
        title: "How Dropshipman fulfills your orders",
        dsc: "Watch the video to learn how Dropshipman fulfill your orders. Get a <strong>$5 coupon</strong> reward for completing the task.",
        video:
          "https://www.youtube.com/embed/1OiyRfrMF74?rel=0&autoplay=1&loop=1",
        isAction: false,
        stepMask: "/buildShopify/new4.png",
        coupon: false,
      },
    ],
    getStartClo: true,
    currentStart: 0, //当前展开步骤
    videoLink: "", //引导视频
    getStartShow: false, // 引导弹窗显示
    popoverDelete: false, // 删除弹层显示
    isNewer: false, // 是否新用户
    isLevel: 0, // 是否会员
    levelTime: "", //会员时间
    couponNum: 0, //优惠券数量
    isPartners: false, // 是否显示广告 false 是打开状态
    noticy: 0, // 消息通知
    getData: {},
    four_banner_pop: true, //四周年活动
  };

  //进入页面调用接口
  componentDidMount() {
    if (AppBridge && AppBridge.exist()) {
      AppBridge.setTitleBar("Dashboard");
    }
    this.GetAppDashboardData();
    this.getBindSaleAndWalletData();
    store.subscribe(() => {
      let person = store.getState().languageReducer.subScriptData;
      let person2 = store.getState().languageReducer.sidebarCountData;
      if (person) {
        this.setState({
          isPartners: person.bfs_pop?.is_bfs_advertisement,
          noticy: person2.messageCount,
        });
      }
    });
  }

  toggleToast = (showToastText, showToastIserror = false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror,
    }));
  };

  /**
   * 更新数组包对象 键值
   * @param {*} opt 源数据
   * @param {string} [optKey='productNum'] 对象KEY
   * @return {Array}
   */
  handleUpdateDataSource(sourceData, opt, productNum, type) {
    return sourceData.map((item, index) => {
      switch (item.n) {
        case 1:
          return {
            ...item,
            [productNum]: opt[type === "sourcing" ? "pend" : "unpaid_count"],
          };
        case 2:
          return {
            ...item,
            [productNum]: type === "sourcing" ? opt["progress"] : 0,
          };
        case 3:
          return {
            ...item,
            [productNum]: type === "order" ? opt["transit"] : 0,
          };
        case 4:
          return {
            ...item,
            [productNum]: type === "sourcing" ? opt["failed"] : 0,
          };
        case 5:
          return {
            ...item,
            [productNum]: opt[type === "sourcing" ? "success" : "delivered"],
          };
        case 7:
          return {
            ...item,
            [productNum]: type === "order" ? opt["undelivered"] : 0,
          };
        default:
          return "";
      }
    });
  }

  //获取数据接口
  GetAppDashboardData = async (time = "last30d") => {
    const params = {
      time_period: time,
    };
    const response = await reqGetAppDashboardData(params);
    if (response.code === "200") {
      var getData = response.data;

      // 处理souringProduct数据
      // let { sourcing_statistic, order_fulfillment } = getData?.statistics_info
      // order_fulfillment = {
      //   delivered:1,
      //   transit:2,
      //   undelivered:3,
      //   unpaid_count:4,
      // }
      const { aliexpress_auth_effective } = getData;
      let list = this.state.newerStartData.map((item, ind) => {
        if (
          Object.values(getData.user_guide).length > 0 &&
          getData.user_guide.step_info[ind + 1]
        ) {
          return { ...item, coupon: true };
        } else {
          return item;
        }
      });
      //是否需要升级订阅用户
      this.setState(
        {
          getData: getData,
          //未处理的订单数量
          toOrderCount: getData.toOrderCount,
          unfulfilled_count: getData.unfulfilled_count,
          //未处理的主动Sourcing数量
          toSourcingCount: getData.toSourcingCount,
          toAwaitingSourcingCount: getData.awaiting_sourcing_count,
          //产品通知数量
          notificationCountArray: getData.notificationCountArray,
          //货币
          symbol: getData.symbol,
          isAuthToAliExpress: getData.isAuthToAliExpress === 1 ? true : false, // 1 已授权(正常)
          loadingPage: false,
          needToUpgrade: getData.level ? false : true,
          ReUpgradeTime: getData.re_time * 1000,
          getGoodReviewActive: getData.prompt ? true : false,
          finishedOnBoarding:
            getData.onBoarding === 0 && getData.level === 0 ? true : false,
          isNewer: getData.onBoarding === 1 ? true : false,
          isLevel: getData.level,
          levelTime: getData.bill_time,
          couponNum: getData.coupon_num,
          // souringProduct: this.handleUpdateDataSource(this.state.souringProduct, sourcing_statistic, 'productNum', 'sourcing'), // Sourcing Products展示数据
          // ordersFulfillment: this.handleUpdateDataSource(this.state.ordersFulfillment, order_fulfillment, 'productNum', 'order'), // order_fulfillment展示数据
          aliexpressAuthEffective: aliexpress_auth_effective, //用户是否授权
          usageGuideInfo: getData.usage_guide_info, // 用户是否首次进入及 用户是否有产品和订单
          affiliate_banner: getData.first_into_affiliate === 0 ? true : false,
          loading: false,
          recommendedCount: getData.recommend_count,
          newerStartData: list, //引导步骤
          four_banner_pop: getData?.four_banner_pop, //四周年活动banner
        },
        () => {
          let usageGuideInfo = this.state.usageGuideInfo;
          /**
           * 判断是否第一次进入
           * 第一次进入 无产品无订单 选中第一个
           * 第一次进入 有产品无订单 选中第二个
           * 第一次进入 有产品有订单 选中第三个
           * 不是第一次进入 选中第一个
           **/
          if (Boolean(usageGuideInfo.first_into_usage_page)) {
            // 第一次进入请求接口
            this.clickDismissFn(1);
            if (
              !Boolean(usageGuideInfo.has_shopify_product) &&
              !Boolean(usageGuideInfo.has_shopify_order)
            ) {
              this.setState({ selectState: 1 }, () => {
                this.clickOrdersItem(this.state.solutionList[0], 0);
              });
            } else if (
              Boolean(usageGuideInfo.has_shopify_product) &&
              !Boolean(usageGuideInfo.has_shopify_order)
            ) {
              this.setState({ selectState: 2 }, () => {
                this.clickOrdersItem(this.state.solutionList[1], 1);
              });
            } else if (
              Boolean(usageGuideInfo.has_shopify_product) &&
              Boolean(usageGuideInfo.has_shopify_order)
            ) {
              this.setState({ selectState: 3 }, () => {
                this.clickOrdersItem(this.state.solutionList[2], 2);
              });
            } else {
              this.setState({ selectState: 1 });
            }
          } else {
            this.setState({ selectState: 1 });
          }
        }
      );

      // 清除浏览器链接上的参数
      try {
        var currentUrl = window.location.href;
        if (currentUrl.indexOf("?") !== -1) {
          currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, "");
          if (!!(window.history && window.history.pushState)) {
            window.history.pushState({}, 0, currentUrl);
          }
        }
      } catch (error) {
        console.warn(error);
      }
    } else {
      this.toggleToast(response.msg);

      // setTimeout(()=>{
      //   if(API_DOMAIN === 'https://api.dropshipman.com'){
      //     window.location.href = 'https://www.dropshipman.com/';
      //   }
      // },1000)
    }
  };

  handleOffFourthBanner = async () => {
    let res = await reqPostBaseAction({ type: "dsm_four_banner" });
    if (res.code === "200") {
      this.setState({
        four_banner_pop: false,
      });
    }
  };

  //点击切换tabs动作
  clickTabsTabSwitch = (name) => {
    //全部删除
    this.setState({
      AliexpressDropshippingCenter: "",
      LinkToAliexpress: "",
      Settings: "",
      AddProducts: "",
      ImportProducts: "",
      ChromeExtension: "",
      Notifications: "",
      MappingProduct: "",
      BulkOrders: "",
    });

    //打开一个
    this.setState({
      [name]: "Tabs_active-tab__3kw-b",
      CurrentlySelectedDiv: name,
    });
  };

  //获取 授权链接，并跳转
  getAuthorizedUrl = async () => {
    this.setState({
      Buttonloading: true,
    });
    const params = {};
    const responseData = await reqGetAliAuthor(params);
    if (responseData.code === "200") {
      this.setState(
        {
          Buttonloading: false,
          authorizeModalShow: false,
        },
        () => {
          // console.info(responseData.data);
          // 修改setting profile父组件 授权按钮状态
          try {
            if (typeof this.props.fuc === "function") {
              this.props.fuc();
            }
          } catch (e) {}

          try {
            // const w = window.open('about:blank');
            // w.location.href = responseData.data;
            window.open(responseData.data);
          } catch (error) {
            window.open(responseData.data);
            // window.location.href = responseData.data;
          }
        }
      );
    } else {
      this.setState(
        {
          Buttonloading: false,
        },
        () => {
          this.toggleToast(responseData.msg);
        }
      );
    }
  };

  // input change
  handleInputChange = (value, filed) => {
    this.setState({
      [filed]: value,
      contactUsTextError: "",
    });
  };

  // 关闭引导升级提示
  handleDisplayUpgradeBanner = (data) => {
    this.setState({ needToUpgrade: false });

    // 记录关闭时间
    if (data.action === 1) {
      this.handleBaseAction("upgrade");
    }
  };

  // 记录日常操作数据
  handleBaseAction = async (type = "") => {
    const params = {
      type: type,
    };
    await reqPostBaseAction(params);
  };

  // 评价弹窗关闭回调
  callBackReviewFunc = () => {
    this.setState({ getGoodReviewActive: false });

    // 记录弹窗的状态
    this.handleBaseAction("dashboard");
  };

  /*
   * 获取绑定销售的信息和钱包余额，是否自动付款
   */
  getBindSaleAndWalletData = async () => {
    const res = await reqGetUserBindSaleAndWallet();
    if (res.code === "200") {
      this.setState({
        SaleId: res.data.bindSale,
        hasSale: res.data.hasSale,
        saleData: res.data.saleData,
        agentData: res.data.agent_info,
        walletMoney: res.data.walletMoney,
        SetProductsPublished: res.data.ProductsPublished,
      });
    }
  };

  /*
    点击绑定销售， 请求接口： 绑定销售
  */
  handleAddSale = async () => {
    if (this.state.SaleId.trim() === "") {
      // this.toggleToast(intl.get("The sales code cannot be empty"), true);
    } else {
      //请求接口添加销售
      this.setState({
        addLoading: true,
      });
      const res = await reqPostUserBindSale({
        bind_sale: this.state.SaleId.trim(),
      });
      this.setState({
        addLoading: false,
      });
      if (res.code === "200") {
        this.toggleToast(res.msg); //请求成功
        this.getBindSaleAndWalletData(); //重新获取销售信息
      } else this.toggleToast(res.msg); //请求错误
    }
  };

  // checkbox change
  handleCheckboxChange = (value, id) => {
    this.setState(
      {
        [id]: value,
      },
      () => {
        // 更新设置
        if (!this.state.saveDataLoading) {
          this.saveData();
        } else {
          setTimeout(() => {
            this.saveData();
          }, 800);
        }
      }
    );
  };

  // save setting
  saveData = async () => {
    this.setState({
      saveDataLoading: true,
    });

    const params = {
      type: "wallet",
      auto_pay: this.state.SetProductsPublished ? 1 : 0,
    };
    const responseData = await reqPostUpdateUserSettings(params);

    this.setState({
      saveDataLoading: false,
    });
    if (responseData.code === "200") {
      this.toggleToast(responseData.msg);
    } else {
      this.toggleToast(responseData.msg);
    }
  };

  // 发送谷歌分析数据
  handleTrackGoogleManager = (sign, data) => {
    try {
      window.gtag("event", sign, data);
    } catch (e) {
      console.log(e);
    }
  };

  // 关闭关闭弹窗
  callChargeActiveClosed = () => {
    this.setState({
      chargeActive: false,
    });
  };

  //点击充值
  handlechargeAuth = async () => {
    //判断金额小于10 就不进入了
    if (Number(this.state.rechargeAmount) < 10) {
      this.setState({
        rechargeAmountError: "Min 10USD",
      });
      return false;
    }
    this.setState({
      AuthButtonDisable: true,
    });

    // 谷歌分析函数
    this.handleTrackGoogleManager("Dropshipman pay charge", {
      domain: utils.getStore("S_SHOP_DOMAIN") || window.S_SHOP_DOMAIN,
      value: Number(this.state.rechargeAmount),
      method: this.state.PaymentMethod === 1 ? "PayPal" : "Stripe",
    });

    //类型 1 PayPal 2 Stripe
    const params = {
      type: this.state.PaymentMethod,
      money: Number(this.state.rechargeAmount),
    };
    const responseData = await reqWalletRecharge(params);

    if (responseData.code === "200") {
      //类型 1 PayPal 2 Stripe
      if (this.state.PaymentMethod === 1) {
        window.location.href = responseData.data.url;
      } else {
        window.location.href = responseData.data.url;
      }
      this.toggleToast(responseData.msg, false);
    } else {
      this.setState({
        AuthButtonDisable: false,
      });
      this.toggleToast(responseData.msg);
    }
  };

  //支付方式
  handleFirstButtonClick = (value) => {
    this.setState({
      PaymentMethod: value,
    });
  };

  //复制文本
  copyTextClick = (event) => {
    let innerText = event.target.innerText;
    var myTagContent = document.createElement("input");
    document.body.appendChild(myTagContent);
    myTagContent.value = innerText;
    myTagContent.select();
    document.execCommand("copy");

    myTagContent.remove();
    this.toggleToast("Copy successfully", false);
  };
  //复制电话 邮箱
  copyClick = (text) => {
    let innerText = text;
    var myTagContent = document.createElement("input");
    document.body.appendChild(myTagContent);
    myTagContent.value = innerText;
    myTagContent.select();
    myTagContent.setAttribute("id", Math.random());
    document.execCommand("copy");
    myTagContent.remove();
    this.toggleToast("Copy successfully", false);
  };

  // 关闭Dismiss弹框操作
  clickDismissFn = async (type) => {
    const params = {
      event: type,
    };
    switch (type) {
      case 1:
        await reqPostPageEventReport(params);
        break;
      case 2:
        this.setState(
          {
            showUsageGuide: false,
          },
          async () => {
            await reqPostPageEventReport(params);
          }
        );
        break;
      case 3:
        this.setState(
          {
            showAliexpressGuide: false,
          },
          async () => {
            await reqPostPageEventReport(params);
          }
        );
        break;
      default:
        return;
    }
  };

  // clickItem 高亮选择时间
  async clickBtnFn(item) {
    const { num } = item;
    this.setState({
      selectFlag: num,
      loading: true,
    });
    this.GetAppDashboardData(num);
  }
  // View Details去对应的详情页面
  goToDetailsPage(item) {
    utils.routeListen("/admin/sourcing");
    utils.routeJump(
      this,
      "/admin/sourcing?type=" + [item.title] + "&num=" + item.n
    );
    // this.props.history.push({
    //   pathname: '/admin/sourcing',
    //   state: {
    //     type: [item.title],
    //     num: item.n
    //   }
    // })
  }

  // 跳转至其他页面
  goToOtherPage() {
    localStorage.setItem("homeViewAuthorizationPageFlag", "1");
    utils.routeListen("/admin/settings/profile");
    utils.routeJump(this, "/admin/settings/profile");
    // this.props.history.push({
    //   pathname: '/admin/settings/profile',
    //   state: {
    //     homePageFlag: true,
    //   },
    // })
  }

  goToAwaitingSourcing() {
    utils.routeListen("/admin/sourcing");
    utils.routeJump(this, "/admin/sourcing?num=3");
    // this.props.history.push({
    //   pathname: '/admin/sourcing',
    //   query: {
    //     num: 3,
    //   },
    // })
  }

  // 是否有授权点击Authorize按钮
  clickAuthorizeBtn() {
    this.state.isAuthToAliExpress
      ? this.toggleToast("Already authorized, no need to re-authorize.", false)
      : this.getAuthorizedUrl();
  }

  // ClickItemEvent
  clickOrdersItem(item, index) {
    let _solutionArr = this.state.solutionList;
    _solutionArr.forEach((item) => {
      item["bgColor"] = "";
      item["h3Color"] = "";
    });
    _solutionArr[index]["bgColor"] = "#f1f1f1";
    _solutionArr[index]["h3Color"] = "#303030";
    this.setState({
      selectState: item.n,
      solutionList: _solutionArr,
    });
  }

  // 物流追踪限制
  handleOrderTrackingUpgrade = () => {
    // let person = Object.values(this.props.languageReducer.subScriptData).length > 0 ? this.props.languageReducer.subScriptData : store.getState().languageReducer.subScriptData;
    let person = store.getState().languageReducer.subScriptData;
    if (person?.level >= 2) {
      utils.routeListen("/admin/order_list");
      utils.routeJump(this, "/admin/order_list");
      // this.props.history.push('/admin/orders_tracking')
    } else {
      this.setState({ upgradeModal: true });
    }
  };
  // 新手引导模块
  // item 展开收缩
  handleItemToggle = (ind) => {
    this.setState({
      currentStart: ind,
    });
  };
  // 打开引导视频并调用接口
  openGuideVideo = (ind, url, coupon) => {
    this.setState({
      getStartShow: true,
      videoLink: url,
      currentStart: ind,
    });
    // 如果没有领取优惠券则调用接口
    if (!coupon) {
      this.openCoupon(ind);
    }
  };
  openCoupon = async (ind) => {
    let params = {
      step: ind + 1,
    };
    let res = await reqPostNoviceCoupon(params);
    if (res.code === "200") {
      this.toggleToast("$5 reward unlocked");
      let list = this.state.newerStartData.map((item, k) => {
        if (k === ind) {
          return { ...item, coupon: true };
        } else {
          return item;
        }
      });
      this.setState({
        newerStartData: list,
      });
    }
  };
  // 更新步骤
  // 关闭引导模块
  handleCloseGuide = async () => {
    let res = await reqPostGuideDismiss();
    if (res.code === "200") {
      this.setState({
        isNewer: false,
      });
    }
  };
  planShow = () => {
    let person = store.getState().languageReducer.subScriptData;
    let flag = false;
    if (
      person.shopify_level !== "Development" &&
      person.shopify_level !== "Developer Preview" &&
      person.shopify_level !== "staff" &&
      person.shopify_level !== "staff_business"
    ) {
      flag = true;
    }
    return flag;
  };

  getYMDStart = (timeStamp) => {
    var dt = new Date(timeStamp);
    var m = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Spt",
      "Oct",
      "Nov",
      "Dec",
    ];
    // var w=["Monday","Tuseday","Wednesday","Thursday","Friday","Saturday","Sunday"];
    var d = ["st", "nd", "rd", "th"];
    var mn = dt.getMonth();
    // var wn= dt.getDay();
    var dn = dt.getDate();
    var dns;
    if (dn % 10 < 1 || dn % 10 > 3) {
      dns = d[3];
    } else {
      dns = d[(dn % 10) - 1];
      if (dn === 11 || dn === 12) {
        dns = d[3];
      }
    }
    return m[mn] + " " + dn + dns + " , " + dt.getFullYear();
  };

  render() {
    const toastMarkup = this.state.showToast ? (
      <Toast
        content={this.state.showToastText}
        onDismiss={() => this.toggleToast("")}
        error={this.state.showToastIserror}
        duration={3000}
      />
    ) : null;

    const {
      hasSale,
      saleData,
      agentData,
      walletMoney,
      // usageGuideInfo,
      // showUsageGuide,
      recommendedCount,
    } = this.state;

    // 默认欢迎语
    let defaultWelcome = intl.get("");

    // 引导视频
    let guideVideo = (
      <div className="novice_video_modal">
        <Modal
          size="large"
          open={this.state.getStartShow}
          onClose={() => this.setState({ getStartShow: false })}
        >
          <div className="plan_grade_content">
            <div className="novice_video_title">
              {Number(this.state.currentStart) === 0 &&
                intl.get("About Dropshipman")}
              {Number(this.state.currentStart) === 1 &&
                intl.get("Find products from Dropshipman")}
              {Number(this.state.currentStart) === 2 &&
                intl.get("How to request a sourcing")}
              {Number(this.state.currentStart) === 3 &&
                intl.get("How Dropshipman fulfills your orders")}
            </div>
            <div className="novice_video_modal_content">
              <iframe
                style={{ borderRadius: "20px" }}
                title="dropshipman"
                src={this.state.videoLink}
                width="880"
                height="500"
                frameBorder="0"
                allowFullScreen="allowfullscreen"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            </div>
          </div>
        </Modal>
      </div>
    );

    // 封装顶部通知
    const topNotice = (fn, prefixIcon, text, tailIcon) => {
      return (
        <div className="lh_min">
          <Card>
            <div className="LayoutLinkColor">
              <Link onClick={fn}>
                <div className="customBanner">
                  <div className="customBannerContent">
                    <div className="iconLeftClass_order">
                      <Icon source={prefixIcon} backdrop={true} />
                    </div>
                    <div className="iconContentClass_order">
                      <Text variant="headingMd" as="h2">
                        {text}
                      </Text>
                    </div>
                  </div>
                  <div>
                    <div className="iconRightClass_order">
                      <Icon source={tailIcon} backdrop={true} />
                    </div>
                    <div style={{ clear: "both" }}></div>
                  </div>
                </div>
              </Link>
            </div>
          </Card>
        </div>
      );
    };

    const initSkeletonPage = (
      <div style={{ padding: "0 2rem" }}>
        <SkeletonPage fullWidth={false}>
          <Layout>
            <Layout.Section>
              <Card>
                <BlockStack gap={400}>
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                </BlockStack>
              </Card>
            </Layout.Section>
          </Layout>
        </SkeletonPage>
      </div>
    );

    //判断显示情况
    var OrdersWaitingToOrder = "";
    var SourcingWaitingResource = "";
    var Notifications = "";

    //未下单数量判断
    if (Number(this.state.toOrderCount) > 0) {
      OrdersWaitingToOrder = topNotice(
        () => {
          utils.routeListen("/admin/order_list");
          utils.routeJump(this, "/admin/order_list");
        },
        OrdersMajor,
        intl.get("{{count}} Order Pending Payment", this.state.toOrderCount),
        ChevronRightMinor
      );
    }

    //未处理的主动Sourcing数量判断
    if (Number(this.state.toSourcingCount) > 0) {
      SourcingWaitingResource = topNotice(
        () => {
          utils.routeListen("/admin/import-list?from=dashboard");
          utils.routeJump(this, "/admin/import-list?from=dashboard");
        },
        // this.props.history.push('/admin/import-list?from=dashboard'),
        ListMajor,
        intl.get(
          "{{count}} products waiting to be imported",
          this.state.toSourcingCount
        ),
        ChevronRightMinor
      );
    }

    //判断通知数量
    if (
      Number(this.state.notificationCountArray.change_status_1) > 0 ||
      Number(this.state.notificationCountArray.change_status_2) > 0 ||
      Number(this.state.notificationCountArray.change_status_3) > 0
    ) {
      //判断是否显示
      var productsUnavailable = "";
      if (Number(this.state.notificationCountArray.change_status_1) > 0) {
        // productsUnavailable = ", " + this.state.notificationCountArray.change_status_1 + " " + intl.get("products unavailable")
        productsUnavailable =
          ", " +
          intl.get(
            "{{count}} products unavailable",
            this.state.notificationCountArray.change_status_1
          );
      }
      var variantsUnavailable = "";
      if (Number(this.state.notificationCountArray.change_status_2) > 0) {
        // variantsUnavailable = ", " + this.state.notificationCountArray.change_status_2 + " " + intl.get("variants unavailable")
        variantsUnavailable =
          ", " +
          intl.get(
            "{{count}} variants unavailable",
            this.state.notificationCountArray.change_status_2
          );
      }
      var productsPriceChanges = "";
      if (Number(this.state.notificationCountArray.change_status_3) > 0) {
        // productsPriceChanges = ", " + this.state.notificationCountArray.change_status_3 + " " + intl.get("products price changes")
        productsPriceChanges =
          ", " +
          intl.get(
            "{{count}} products price changes",
            this.state.notificationCountArray.change_status_3
          );
      }
      Notifications = topNotice(
        () => {
          utils.routeListen("/admin/notifications");
          utils.routeJump(this, "/admin/notifications");
        },
        NotificationMajor,
        `${intl.get(
          "{{AllCount}} Notifications",
          this.state.notificationCountArray.AllCount
        )} ${productsUnavailable} ${variantsUnavailable} ${productsPriceChanges}`,
        ChevronRightMinor
      );
    }

    // 欢迎语展示
    let owerName = utils.getStore("S_SHOP_OWNER") || window.S_SHOP_OWNER;
    if (
      OrdersWaitingToOrder === "" &&
      Notifications === "" &&
      SourcingWaitingResource === ""
    ) {
      if (owerName !== "") {
        defaultWelcome = intl.get(
          "Hi {{owerName}}, welcome to Dropshipman",
          owerName
        );
      } else {
        defaultWelcome = intl.get("Welcome to Dropshipman.");
      }
    }

    // sourcing 待确认提示
    let sourcingWaitingContent = "";
    if (this.state.toAwaitingSourcingCount > 0) {
      sourcingWaitingContent = topNotice(
        () => this.goToAwaitingSourcing(),
        ResourcesMajor,
        intl.get(
          `{toAwaitingSourcingCount} sourcing products waiting for your confirmation`,
          this.state.toAwaitingSourcingCount
        ),
        ChevronRightMinor
      );
    }

    // 推荐商品顶部通知
    const RecommendNotice = recommendedCount
      ? topNotice(
          () => {
            utils.routeListen("/admin/import-list?type=dsm_recommend");
            utils.routeJump(this, "/admin/import-list?type=dsm_recommend");
          },
          PackageMajor,
          intl.get("{{count}} products recommended for you", recommendedCount),
          ChevronRightMinor
        )
      : null;

    const pageContent = this.state.loadingPage ? (
      initSkeletonPage
    ) : (
      <div id="homePage" style={{ paddingLeft: 20, paddingRight: 20 }}>
        <Page fullWidth={false}>
          {this.state.four_banner_pop && (
            <FourthBannerEvent
              level={Number(this.state.isLevel)}
              handleOffFourthBanner={this.handleOffFourthBanner}
            />
          )}
          <div className="Polaris-Page-Header Dashboard_Title">
            <div className="Polaris-Header-Title">
              <h1
                style={{
                  fontSize: "20px",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  style={{ marginRight: "8px" }}
                  width={30}
                  src={"/buildShopify/welcome.png"}
                  alt="dropshipman"
                />{" "}
                {defaultWelcome}
              </h1>
            </div>
          </div>
          <Layout>
            {/*左边布局*/}
            <Layout.Section>
              <BlockStack gap="600">
                {/* 新手引导 */}
                {this.state.isNewer && (
                  <Card>
                    <BlockStack gap="200">
                      <InlineGrid columns="1fr auto">
                        <span style={{ fontSize: "16px", fontWeight: 600 }}>
                          {intl.get("Get started with Dropshipman")}
                        </span>
                        <InlineStack align="space-between">
                          <Box>
                            <Popover
                              active={this.state.popoverDelete}
                              activator={
                                <Button
                                  variant="tertiary"
                                  onClick={() =>
                                    this.setState({ popoverDelete: true })
                                  }
                                >
                                  <Icon
                                    source={MobileHorizontalDotsMajor}
                                    tone="base"
                                  />
                                </Button>
                              }
                              autofocusTarget="first-node"
                              onClose={() =>
                                this.setState({ popoverDelete: false })
                              }
                            >
                              <ActionList
                                actionRole="menuitem"
                                items={[
                                  {
                                    content: (
                                      <div
                                        onClick={() => this.handleCloseGuide()}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <Icon
                                          source={CancelMajor}
                                          tone="base"
                                        />
                                        {intl.get("Dismiss")}
                                      </div>
                                    ),
                                  },
                                ]}
                              />
                            </Popover>
                          </Box>
                          <Box>
                            {this.state.getStartClo ? (
                              <Button
                                variant="tertiary"
                                onClick={() =>
                                  this.setState({ getStartClo: false })
                                }
                              >
                                <Icon source={CaretUpMinor} tone="base" />
                              </Button>
                            ) : (
                              <Button
                                variant="tertiary"
                                onClick={() =>
                                  this.setState({ getStartClo: true })
                                }
                              >
                                <Icon source={CaretDownMinor} tone="base" />
                              </Button>
                            )}
                          </Box>
                        </InlineStack>
                      </InlineGrid>
                      <Box>
                        <InlineStack blockAlign="center">
                          <Text as="p" variant="bodyMd">
                            {intl.get(
                              "{{tasks}} of 4 tasks completed",
                              this.state.newerStartData.filter(
                                (item) => item.coupon
                              ).length
                            )}
                          </Text>
                          <div
                            className="progressbar"
                            style={{
                              flex: 1,
                              marginLeft: "16px",
                              display: "inline-block",
                            }}
                          >
                            <ProgressBar
                              progress={
                                (this.state.newerStartData.filter(
                                  (item) => item.coupon
                                ).length /
                                  4) *
                                100
                              }
                              size="small"
                              tone="primary"
                            />
                          </div>
                        </InlineStack>
                      </Box>
                      <Collapsible
                        open={this.state.getStartClo}
                        id="basic-collapsible"
                        transition={{
                          duration: "500ms",
                          timingFunction: "ease-in-out",
                        }}
                        expandOnPrint
                      >
                        <Box className="get_start_list">
                          {this.state.newerStartData.map((item, ind) => (
                            <Box
                              key={ind}
                              className={
                                this.state.currentStart === ind
                                  ? "get_start_items get_start_item"
                                  : "get_start_item"
                              }
                            >
                              <Box
                                className="get_start_item_p"
                                style={{
                                  padding: "0 16px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                onClick={() => this.handleItemToggle(ind)}
                              >
                                {/* <RadioButton label={""} checked={item.coupon} /> */}
                                {item.coupon ? (
                                  <NewStartBlack />
                                ) : (
                                  <NewStartNone />
                                )}
                                <Text as="p" variant="bodyMd">
                                  {item.title}
                                </Text>
                              </Box>
                              <Collapsible
                                open={
                                  Number(this.state.currentStart) ===
                                  Number(ind)
                                }
                                id="basic-collapsible"
                                transition={{
                                  duration: "200ms",
                                  timingFunction: "ease-in-out",
                                }}
                                expandOnPrint
                              >
                                <Box className="get_start_item_text">
                                  <Box
                                    className={
                                      this.planShow()
                                        ? `get_start_item_text_title get_start_item_text_title_plan`
                                        : `get_start_item_text_title `
                                    }
                                  >
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: item.dsc,
                                      }}
                                    ></span>
                                  </Box>
                                  <Box
                                    className="get_start_item_text_img"
                                    onClick={() =>
                                      this.openGuideVideo(
                                        ind,
                                        item.video,
                                        item.coupon
                                      )
                                    }
                                  >
                                    <img
                                      src={item.stepMask}
                                      alt="dropshipman"
                                    />
                                  </Box>
                                </Box>
                              </Collapsible>
                            </Box>
                          ))}
                        </Box>
                      </Collapsible>
                    </BlockStack>
                  </Card>
                )}

                {/* 商品推荐 通知*/}
                {RecommendNotice}

                {/* {Notifications} */}
                {Number(this.state.noticy) > 0 && (
                  <div className="lh_min">
                    <Card>
                      <div className="LayoutLinkColor">
                        <Link
                          onClick={() => {
                            utils.routeListen("/admin/messages");
                            utils.routeJump(this, "/admin/messages");
                          }}
                        >
                          <div className="customBanner">
                            <div className="customBannerContent">
                              <div className="iconLeftClass_order">
                                <Icon
                                  source={NotificationMajor}
                                  backdrop={true}
                                />
                              </div>
                              <div className="iconContentClass_order">
                                <Text variant="headingMd" as="h2">
                                  {intl.get(
                                    "{noticy} notifications",
                                    this.state.noticy
                                  )}
                                </Text>
                              </div>
                            </div>
                            <div>
                              <div className="iconRightClass_order">
                                <Icon
                                  source={ChevronRightMinor}
                                  backdrop={true}
                                />
                              </div>
                              <div style={{ clear: "both" }}></div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </Card>
                  </div>
                )}
                {OrdersWaitingToOrder}

                {SourcingWaitingResource}
                {/* sourcing 待确认提示 */}
                {sourcingWaitingContent}

                {/* 销售 */}
                {hasSale  && (
                  Object.values(agentData).length > 0 && <Box className="sale_manager_content">
                    <div
                      className="fulfilled_orders_content_top_title"
                      style={{ margin: "16px 0" }}
                    >
                      Personal Agent
                    </div>
                    <Box className="sale_manager_content_item">
                      <Box className="sale_manager_content_left">
                        <img
                          src={
                            agentData?.avatar_url
                              ? agentData?.avatar_url
                              : "/customer_service.png"
                          }
                          alt="dropshipman"
                        />
                      </Box>
                      <Box className="sale_manager_content_right">
                        {agentData?.name && (
                          <Box className="sale_manager_content_right_bottom">
                            <Text variant="headingLg" as="h6">
                              {agentData?.name}
                            </Text>
                            <Box>
                              <div className="mt15 sale_manager_content_right_bottom_dsc">
                                {agentData?.email && (
                                  <div
                                    className="personal-agent__bottom"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      margin: "0 10px",
                                    }}
                                  >
                                    <span>
                                      <img
                                        height={22}
                                        src="/buildShopify/InviteMinor.png"
                                        alt="dropshipman"
                                      />
                                    </span>
                                    <span
                                      className="pf10"
                                      title={agentData?.email}
                                    >
                                      {agentData?.email}
                                    </span>
                                    <span
                                      className="pf5"
                                      onClick={() =>
                                        this.copyClick(agentData?.email)
                                      }
                                    >
                                      <Icon
                                        source={DuplicateMinor}
                                        tone="base"
                                      />
                                    </span>
                                  </div>
                                )}

                                {agentData?.whatsapp && (
                                  <div
                                    className="personal-agent__bottom"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      margin: "0 10px",
                                    }}
                                  >
                                    <span>
                                      <img
                                        height={22}
                                        src="/buildShopify/phone.png"
                                        alt="dropshipman"
                                      />
                                    </span>
                                    <span
                                      className="pf10"
                                      title={agentData?.whatsapp}
                                    >
                                      {agentData?.whatsapp}
                                    </span>
                                    <span
                                      onClick={() =>
                                        this.copyClick(agentData?.whatsapp)
                                      }
                                      className="pf5"
                                    >
                                      <Icon
                                        source={DuplicateMinor}
                                        tone="base"
                                      />
                                    </span>
                                  </div>
                                )}
                                {agentData?.skype && (
                                  <div
                                    className="personal-agent__bottom"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      margin: "0 10px",
                                    }}
                                  >
                                    <span>
                                      <img
                                        height={22}
                                        src="/buildShopify/skype_fill.png"
                                        alt="dropshipman"
                                      />
                                    </span>
                                    <span
                                      className="pf10"
                                      title={agentData?.skype}
                                    >
                                      {agentData?.skype?.slice(0, 36)}
                                    </span>
                                    <span
                                      onClick={() =>
                                        this.copyClick(agentData?.skype)
                                      }
                                      className="pf5"
                                    >
                                      <Icon
                                        source={DuplicateMinor}
                                        tone="base"
                                      />
                                    </span>
                                  </div>
                                )}
                              </div>
                            </Box>
                          </Box>
                        )}
                        {agentData?.name && (
                          <Box
                            style={{
                              display: "flex",
                              alignItem: "center",
                              margin: "16px 0",
                            }}
                            className="agent_content_star_box"
                          >
                            {agentData.service_rating > 0 && (
                              <Box
                                className="agent_content_box_rating"
                                style={{
                                  position: "relative",
                                  marginRight: "24px",
                                }}
                              >
                                <StartRating
                                  value={agentData.service_rating}
                                  color1="gray"
                                  color2="#ffd700"
                                  half={true}
                                  count={5}
                                  edit={false}
                                  size={16}
                                />
                                <span
                                  style={{
                                    position: "absolute",
                                    left: "108px",
                                    fontSize: 14,
                                    top: "2px",
                                  }}
                                >
                                  {agentData.service_rating}{" "}
                                </span>
                              </Box>
                            )}
                            <Box className="agent_content_box_tag" style={{marginLeft: "24px"}}>
                              {agentData.service_tags.map((it, k) => (
                                <span key={k}>{it}</span>
                              ))}
                            </Box>
                          </Box>
                        )}
                        <Box className="sale_manager_content_right_top">
                          <span>{agentData?.introduction && "“"}</span>
                          <p>{agentData?.introduction}</p>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
                 { hasSale  && Object.values(saleData).length > 0 && <Box className="sale_manager_content">
                    <div
                      className="fulfilled_orders_content_top_title"
                      style={{ margin: "16px 0" }}
                    >
                      Dedicated Manager
                    </div>
                    <Box className="sale_manager_content_item">
                      <Box className="sale_manager_content_left">
                        <img
                          src={
                            saleData?.avatar_url
                              ? saleData?.avatar_url
                              : "/customer_service.png"
                          }
                          alt="dropshipman"
                        />
                      </Box>
                      <Box className="sale_manager_content_right">
                        <Box className="sale_manager_content_right_top">
                          <span>{saleData?.introduction && "“"}</span>
                          <p>{saleData?.introduction}</p>
                        </Box>
                        {saleData?.name && (
                          <Box className="sale_manager_content_right_bottom">
                            <Text variant="headingLg" as="h6">
                              {saleData?.name}
                            </Text>
                            <Box>
                              <div className="mt15 sale_manager_content_right_bottom_dsc">
                                {saleData?.email && (
                                  <div
                                    className="personal-agent__bottom"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      margin: "0 10px",
                                    }}
                                  >
                                    <span>
                                      <img
                                        height={22}
                                        src="/buildShopify/InviteMinor.png"
                                        alt="dropshipman"
                                      />
                                    </span>
                                    <span
                                      className="pf10"
                                      title={saleData?.email}
                                    >
                                      {saleData?.email}
                                    </span>
                                    <span
                                      className="pf5"
                                      onClick={() =>
                                        this.copyClick(saleData?.email)
                                      }
                                    >
                                      <Icon
                                        source={DuplicateMinor}
                                        tone="base"
                                      />
                                    </span>
                                  </div>
                                )}

                                {saleData?.whatsapp && (
                                  <div
                                    className="personal-agent__bottom"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      margin: "0 10px",
                                    }}
                                  >
                                    <span>
                                      <img
                                        height={22}
                                        src="/buildShopify/phone.png"
                                        alt="dropshipman"
                                      />
                                    </span>
                                    <span
                                      className="pf10"
                                      title={saleData?.whatsapp}
                                    >
                                      {saleData?.whatsapp}
                                    </span>
                                    <span
                                      onClick={() =>
                                        this.copyClick(saleData?.whatsapp)
                                      }
                                      className="pf5"
                                    >
                                      <Icon
                                        source={DuplicateMinor}
                                        tone="base"
                                      />
                                    </span>
                                  </div>
                                )}
                                {saleData?.skype && (
                                  <div
                                    className="personal-agent__bottom"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      margin: "0 10px",
                                    }}
                                  >
                                    <span>
                                      <img
                                        height={22}
                                        src="/buildShopify/skype_fill.png"
                                        alt="dropshipman"
                                      />
                                    </span>
                                    <span
                                      className="pf10"
                                      title={saleData?.skype}
                                    >
                                      {saleData?.skype?.slice(0, 36)}
                                    </span>
                                    <span
                                      onClick={() =>
                                        this.copyClick(saleData?.skype)
                                      }
                                      className="pf5"
                                    >
                                      <Icon
                                        source={DuplicateMinor}
                                        tone="base"
                                      />
                                    </span>
                                  </div>
                                )}
                              </div>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                }

                {/* 按钮模块 订阅、钱包、优惠券 */}
                <Box className="module_content_list">
                  {this.planShow() ? (
                    <Box
                      className="module_content_item"
                      onClick={() => {
                        utils.routeListen("/admin/subscribe");
                        utils.routeJump(this, "/admin/subscribe");
                      }}
                    >
                      <Box className="module_content_item_img">
                        <span>
                          <img
                            src={
                              Number(this.state.isLevel) > 0
                                ? "/sub/icon_head.png"
                                : "/buildShopify/head1.png"
                            }
                            alt="dropshipman"
                          />
                        </span>
                        <Text variant="headingLg" as="h6">
                          {intl.get("Plan")}
                        </Text>
                      </Box>
                      <Box className="module_content_item_dsc">
                        <span style={{ minWidth: "80px", textAlign: "center" }}>
                          {Number(this.state.isLevel) === 0 && intl.get("Free")}
                          {Number(this.state.isLevel) === 1 && intl.get("PRO")}
                          {Number(this.state.isLevel) >= 2 &&
                            Number(this.state.isLevel) <= 3 &&
                            intl.get("PLUS")}
                          {Number(this.state.isLevel) === 4 &&
                            intl.get("Basic")}
                          {Number(this.state.isLevel) === 5 && "Premium"}
                        </span>
                        <Icon source={ChevronRightMinor} tone="base" />
                      </Box>
                      {(Number(this.state.isLevel) > 0 && Number(this.state.levelTime) > 0) ? (
                        <p style={{ color: "rgba(138, 138, 138, 1)" }}>
                          {intl.get("Due")}:{" "}
                          {this.getYMDStart(this.state.levelTime * 1000)}
                        </p>
                      ) : (
                        ""
                      )}
                    </Box>
                  ) : (
                    <Box
                      className="module_content_item"
                      // onClick={() => {
                      //   utils.routeListen("/admin/subscribe");
                      //   utils.routeJump(this, "/admin/subscribe");
                      // }}
                    >
                      <Box className="module_content_item_img">
                        <span>
                          <img
                            src={
                              Number(this.state.isLevel) > 0
                                ? "/sub/icon_head.png"
                                : "/buildShopify/head1.png"
                            }
                            alt="dropshipman"
                          />
                        </span>
                        <Text variant="headingLg" as="h6">
                          {intl.get("Plan")}
                        </Text>
                      </Box>
                      <Box className="module_content_item_dsc">
                        <span style={{ minWidth: "80px", textAlign: "center" }}>
                          {Number(this.state.isLevel) === 0 && intl.get("Free")}
                          {Number(this.state.isLevel) === 1 && intl.get("PRO")}
                          {Number(this.state.isLevel) >= 2 &&
                            Number(this.state.isLevel) <= 3 &&
                            intl.get("PLUS")}
                          {Number(this.state.isLevel) === 4 &&
                            intl.get("Basic")}
                          {Number(this.state.isLevel) === 5 && "Premium"}
                        </span>
                        {/* <Icon
                      source={ChevronRightMinor}
                      tone="base"
                    /> */}
                      </Box>
                      {(Number(this.state.isLevel) > 0 && Number(this.state.levelTime) > 0) ? (
                        <p style={{ color: "rgba(138, 138, 138, 1)" }}>
                          {intl.get("Due")}:{" "}
                          {this.getYMDStart(this.state.levelTime * 1000)}
                        </p>
                      ) : (
                        ""
                      )}
                    </Box>
                  )}
                  <Box
                    className="module_content_item"
                    onClick={() => {
                      utils.routeListen("/admin/wallet");
                      utils.routeJump(this, "/admin/wallet");
                    }}
                  >
                    <Box className="module_content_item_img">
                      <span>
                        <img
                          src="/buildShopify/credit1.png"
                          alt="dropshipman"
                        />
                      </span>
                      <Text variant="headingLg" as="h6">
                        {intl.get("Credits")}
                      </Text>
                    </Box>
                    <Box className="module_content_item_dsc">
                      <span style={{ minWidth: "80px", textAlign: "center" }}>
                        {walletMoney}
                      </span>
                      <Icon source={ChevronRightMinor} tone="base" />
                    </Box>
                    {(Number(this.state.isLevel) > 0 && Number(this.state.levelTime) > 0) ? (
                      <p style={{ visibility: "hidden" }}>{intl.get("Due")}:</p>
                    ) : (
                      ""
                    )}
                  </Box>
                  <Box
                    className="module_content_item"
                    onClick={() => {
                      utils.routeListen("/admin/coupon");
                      utils.routeJump(this, "/admin/coupon");
                    }}
                  >
                    <Box className="module_content_item_img">
                      <span>
                        <img
                          src="/buildShopify/coupons1.png"
                          alt="dropshipman"
                        />
                      </span>
                      <Text variant="headingLg" as="h6">
                        {intl.get("Coupons")}
                      </Text>
                    </Box>
                    <Box className="module_content_item_dsc">
                      <span style={{ minWidth: "80px", textAlign: "center" }}>
                        {this.state.couponNum}
                      </span>
                      <Icon source={ChevronRightMinor} tone="base" />
                    </Box>
                    {(Number(this.state.isLevel) > 0 && Number(this.state.levelTime) > 0) ? (
                      <p style={{ visibility: "hidden" }}>{intl.get("Due")}:</p>
                    ) : (
                      ""
                    )}
                  </Box>
                </Box>
              </BlockStack>
              {this.state.loading ? (
                <div className="loading">
                  <Spinner accessibilityLabel="loading" size="large" />
                </div>
              ) : (
                <div>
                  {/* <HomeStatistics selectDateFlag={this.state.selectFlag} statisticsData={this.state.ordersFulfillment} title="Orders Fulfillment (Dropshipman)" />
                  <HomeStatistics selectDateFlag={this.state.selectFlag} statisticsData={this.state.souringProduct} title="Sourcing Products" /> */}
                  <FulfilledOrders
                    unfulfilledCount={this.state.unfulfilled_count}
                  />
                  {/* 推荐App列表 */}
                  {!this.state.isPartners && (
                    <AppRecommendation
                      show={!this.state.isPartners}
                      setIsPartners={() => this.setState({ isPartners: true })}
                      history={this.props.history}
                    />
                  )}
                </div>
              )}
            </Layout.Section>
          </Layout>
        </Page>
      </div>
    );

    return (
      <div style={{ minHeight: "800px" }}>
        {pageContent}
        {toastMarkup}
        {/* 升级为会员弹窗 */}
        <UpgradePlanModal
          upgradeOpen={this.state.upgradeModal}
          setUpgradeOpen={() => this.setState({ upgradeModal: false })}
        />

        {/* 升级为会员弹窗 */}
        <UpgradeDiscountModal
          upgradeOpen={false}
          setUpgradeOpen={() => this.setState({ isNewUser: false })}
        />

        {/* 引导视频 */}
        {guideVideo}

        {/* 获取好评弹窗 */}
        <GetGoodReviews
          heading_title={intl.get("Bring You A Better Experience!")}
          subtitle={intl.get(
            "Would you mind letting us know what you think about us?"
          )}
          prompt_title={intl.get(
            "Your valuable review will motivate us to improve."
          )}
          show={this.state.getGoodReviewActive}
          checkTime={false}
          checkDashboard={true}
          callBack={this.callBackReviewFunc}
        />
      </div>
    );
  }
}
// const mapStateToProps = state => {
//   return {
//     languageReducer: state.languageReducer
//   }
// }

export default withRouter(Dashboard);
